import React from "react";

import { Select } from "antd";
import propTypes from "prop-types";
import Spin from "shared/components/Spin";

import FloatLabel from "./FloatingLabel";
import "./styles.scss";

const { Option } = Select;

const Component = ({ placeholder, items, loading, onChange, ...props }) => (
  <FloatLabel
    className="container--input"
    label={placeholder}
    labelLeft={"label--left"}
    value={props.value}>
    <Select
      notFoundContent={loading ? <Spin size="small" /> : null}
      showSearch
      size="large"
      onSelect={onChange}
      {...props}>
      {items.map((item) => (
        <Option value={item.value} key={`option-${item.value}`}>
          {item.label}
        </Option>
      ))}
    </Select>
  </FloatLabel>
);

Component.propTypes = {
  items: propTypes.arrayOf(
    propTypes.shape({
      label: propTypes.string,
      value: propTypes.string,
    }),
  ),
  placeholder: propTypes.string,
  value: propTypes.string,
  onChange: propTypes.func,
  loading: propTypes.bool,
  hidePlaceholder: propTypes.bool,
};

Component.defaultProps = {
  placeholder: "",
  value: "",
  hidePlaceholder: false,
  onChange: () => {},
};

export default Component;
